import { TicketRequest } from '@/modules/contacts/shared/domain/tickets-request.interface';
import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class ContactsRepository extends HttpRepository {
    private static readonly CONTACTS_RESOURCE = 'contacts';

    async checkIfContactExists(payload): Promise<{ data: { status: number; message: string } }> {
        return this.post(
            this.createUri([`${ContactsRepository.CONTACTS_RESOURCE}`, 'validate']),
            payload,
            this.createAuthorizationHeader(),
        );
    }

    async createContact(payload: TicketRequest): Promise<{}> {
        return this.post(this.createUri(['tickets']), payload, this.createAuthorizationHeader());
    }

    async updateContact(contact: TicketRequest) {
        return this.createContact(contact);
    }

    async getContact(id: number) {
        return this.get(this.createUri([`contacts/${id}`]), this.createAuthorizationHeader());
    }

    async deleteContact(contact: TicketRequest) {
        return this.createContact(contact);
    }
}

export const contactsRepository = new ContactsRepository();
